import React from 'react';

import { TopImpactStoryBubble } from '../TopImpactStoryBubble';

import { useTopImpactStoriesDesktop } from './hooks/useTopImpactStoriesDesktop';

type Props = {
	/**
	 * "staggered" (default) - overlapping orbit layout, row height driven by the centered bubble.
	 * "row" - all bubbles in normal flow, row height driven by the tallest bubble.
	 */
	layout?: 'staggered' | 'row';
};

export const TopImpactStoriesDesktop: React.FC<Props> = ({ layout = 'staggered' }) => {
	const {
		data: { desktopStories },
		actions: { trackStoryClick },
	} = useTopImpactStoriesDesktop();

	return (
		<div className="hidden grid-cols-5 gap-6 lg:mt-10 lg:grid xl:mt-10" data-testid="top-impact-stories-container">
			{desktopStories.map((story) => (
				<TopImpactStoryBubble key={story.key} story={story} layout={layout} trackStoryClick={trackStoryClick} />
			))}
		</div>
	);
};
